
import { Component, EventEmitter, OnInit, Output, Injector, inject } from '@angular/core';
import { Stkpi01PkgComponent } from './stkpi01Pkg.component';
import { MaterialModule } from 'jk-service';
import { JkBillFormComponent } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';
import { Stkpi01DetailComponent } from './stkpi01-detailPkg.component';

@Component({
  selector: 'app-stkpi01-bill',
  standalone: true,
  imports: [MaterialModule, JackBaseComponentModule, Stkpi01PkgComponent, Stkpi01DetailComponent],
  templateUrl: './stkpi01BillPkg.component.html',
  styleUrls: [],
})
export class Stkpi01BillComponent extends JkBillFormComponent implements OnInit {
  override _programId = 'stkpi01'; //###
  override masterPage!: Stkpi01PkgComponent;
  override detailPage!: Stkpi01DetailComponent;
  constructor() {
    super();
    this.setFormOpt2(); //###
  }

  override ngOnInit() {
    super.ngOnInit();
  }
  override async ngAfterViewInit() {
    super.ngAfterViewInit();
  }
  override doMasterPageReady($event: any) {
    super.doMasterPageReady($event);
  }
  // 以下客製 --------------------------------------------------------


}
